import { Dispatch } from "redux";
import { getDetailProduct } from "../action/detailMenu.action";
import { displayLoader } from "../action/loader.action";
import api from "./index.api";

export const getAllDetailProduct = (id: string) => (dispatch: Dispatch) => {
    api.get(`/products/${id}`)
        .then((response) => {
            dispatch(displayLoader(false));
            dispatch(getDetailProduct(response.data.data));
        })
        .catch((err) => {
            dispatch(displayLoader(false));
        });
};
